import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal as ModalComponent, ModalBody, ModalFooter } from 'reactstrap';
import classnames from 'classnames';
import _ from 'lodash';

import { buttons as Buttons } from '@breezeway/brzw-components';

import './modal.scss';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
  }

  toggle(e) {
    _.invoke(e, 'preventDefault');
    _.invoke(e, 'stopPropagation');

    _.invoke(this.props, 'onClose');
  }

  render() {
    const {
      children,
      className,
      closeIconName,
      footer,
      full,
      header,
      headerPhoto,
      isOpen,
      modalClassName,
      onClickBack,
      title,
      withBodyScroll,
      withCloseIcon,
      wrapClassName,
    } = this.props;
    return (
      <ModalComponent
        backdropClassName="modal-popup__backdrop"
        className={classnames('modal-popup', className, {
          '-with-body-scroll': withBodyScroll,
          '-with-photo': headerPhoto,
          '-full-height': full,
        })}
        isOpen={isOpen}
        modalClassName={modalClassName}
        toggle={this.toggle}
        wrapClassName={classnames('modal-popup__wrapper', wrapClassName)}
        zIndex={2000}
      >
        <div className="modal-popup__header-wrapper">
          <div className="modal-popup__header-content">
            {header || <h4 className="modal-popup__title">{title}</h4>}
            {headerPhoto && <div className="modal-popup__photo">{headerPhoto}</div>}
            {onClickBack && !headerPhoto && (
              <Buttons.IconTextButton
                className="modal-popup__header-back-btn"
                iconNameLeft="chevron-left"
                onClick={onClickBack}
                size={Buttons.constants.BUTTON_SIZES.X_SMALL}
                theme={Buttons.constants.BUTTON_THEMES.LINK}
              >
                Back
              </Buttons.IconTextButton>
            )}
          </div>
          {withCloseIcon && (
            <Buttons.IconButton
              className="modal-popup__header-close"
              iconName={closeIconName}
              onClick={this.toggle}
              size={Buttons.constants.BUTTON_SIZES.ICON_X_SMALL}
              theme={Buttons.constants.BUTTON_THEMES.LINK}
            />
          )}
        </div>
        <ModalBody>{children}</ModalBody>
        {footer && <ModalFooter>{footer}</ModalFooter>}
      </ModalComponent>
    );
  }
}

Modal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  closeIconName: PropTypes.string,
  footer: PropTypes.shape({}),
  full: PropTypes.bool,
  header: PropTypes.shape({}),
  headerPhoto: PropTypes.node,
  isOpen: PropTypes.bool,
  modalClassName: PropTypes.string,
  onClickBack: PropTypes.func,
  // eslint-disable-next-line react/no-unused-prop-types
  onClose: PropTypes.func.isRequired,
  subHeader: PropTypes.shape({}),
  title: PropTypes.string,
  withBodyScroll: PropTypes.bool,
  withCloseIcon: PropTypes.bool,
  wrapClassName: PropTypes.string,
};

Modal.defaultProps = {
  className: '',
  closeIconName: 'circle-close',
  full: false,
  isOpen: true,
  modalClassName: '',
  withCloseIcon: true,
  wrapClassName: '',
};

export default Modal;
